module.exports = __webpack_public_path__ + "img/remainder1.507ac95b.svg";